const MAX_CODE_CHARS = 12000;
const MAX_RESULT_CHARS = 256 * 1024;
const TIMEOUT_MS = 3000;
// `document` is the documented, read-only workspace data context. Keep
// browser globals blocked without rejecting valid expressions such as
// `document.rows` and `documents[0].text`.
const FORBIDDEN_CODE = /\b(?:fetch|xmlhttprequest|websocket|importscripts|indexeddb|webassembly|globalthis|self|window|navigator|location|postmessage|settimeout|setinterval|eval|function|constructor|prototype|__proto__|sharedarraybuffer|atomics)\b/i;

function validateCode(code) {
  const source = String(code || '').trim();
  if (!source) throw new Error('工作区解析代码不能为空。');
  if (source.length > MAX_CODE_CHARS) throw new Error(`工作区解析代码不能超过 ${MAX_CODE_CHARS} 个字符。`);
  if (!/\breturn\b/.test(source)) throw new Error('工作区解析代码必须使用 return 返回结果。');
  if (FORBIDDEN_CODE.test(source)) throw new Error('工作区解析代码包含不允许访问的浏览器或网络 API。');
  return source;
}

export function executeWorkspaceCode(code, context = {}) {
  const source = validateCode(code);
  if (typeof Worker === 'undefined') throw new Error('当前浏览器不支持工作区代码解析。');
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('./workspaceEval.worker.js', import.meta.url));
    let settled = false;
    const cleanup = () => worker.terminate();
    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      cleanup();
      callback(value);
    };
    const timer = setTimeout(() => finish(reject, new Error('工作区解析代码执行超时（3 秒）。')), TIMEOUT_MS);
    worker.onmessage = event => {
      if (event.data && event.data.ok) finish(resolve, event.data.value);
      else finish(reject, new Error((event.data && event.data.error) || '工作区解析代码执行失败'));
    };
    worker.onerror = () => finish(reject, new Error('工作区解析代码执行失败。'));
    worker.postMessage({
      code: source,
      document: context.document || null,
      documents: context.documents || [],
      metadata: context.metadata || {},
      // Compatibility context for workspace_excel_eval. These aliases are
      // plain structured-clone data and do not expose browser globals.
      rows: context.rows || [],
      sheets: context.sheets || {},
      helpers: context.helpers || {},
      maxResultChars: MAX_RESULT_CHARS
    });
  });
}

export { MAX_CODE_CHARS, MAX_RESULT_CHARS, validateCode };
